import { DETECT_MOUSE_STATE } from "../constants/actionTypes";

export default function(state = "normal", action) {
  switch (action.type) {
    case DETECT_MOUSE_STATE:
      return action.payload;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/mouseStateReducer.js